import {
    createBaseThemeOptions,
    createUnifiedTheme,
    genPageTheme,
    palettes,
    shapes
} from '@backstage/theme';

export const finayaTheme = createUnifiedTheme({
    ...createBaseThemeOptions({
        palette: {
            ...palettes.dark,
            primary: {
                main: '#fc8404',
            },
            // secondary: {
            //     main: '#6c248c',
            // },
            // error: {
            //     main: '#ec0c5c',
            // },
            // warning: {
            //     main: '#6c248c',
            // },
            // info: {
            //     main: '#14a4dc',
            // },
            // success: {
            //     main: '#485e30',
            // },
            // background: {
            //     default: '#d5d6db',
            //     paper: '#d5d6db',
            // },
            // banner: {
            //     info: '#34548a',
            //     error: '#8c4351',
            //     text: '#343b58',
            //     link: '#565a6e',
            // },
            // errorBackground: '#8c4351',
            // warningBackground: '#8f5e15',
            // infoBackground: '#343b58',
            navigation: {
                background: '',
                indicator: '#6c2c8c',
                color: '#d5d6db',
                selectedColor: '#ffffff',
            },
        },
    }),
    // defaultPageTheme: 'home',
    /* below drives the header colors */
    pageTheme: {
        home: genPageTheme({ colors: ['#6c2c8c', '#6c2c8c', '#6c2c8c', '#6c248c'], shape: shapes.wave }),
        documentation: genPageTheme({
            colors: ['#6c2c8c', '#6c2c8c', '#6c2c8c', '#6c248c'],
            shape: shapes.wave2,
        }),
        tool: genPageTheme({ colors: ['#6c2c8c', '#6c2c8c', '#6c2c8c', '#6c248c'], shape: shapes.round }),
        service: genPageTheme({
            colors: ['#6c2c8c', '#6c2c8c', '#6c2c8c', '#6c248c'],
            shape: shapes.wave,
        }),
        website: genPageTheme({
            colors: ['#6c2c8c', '#6c2c8c', '#6c2c8c', '#6c248c'],
            shape: shapes.wave,
        }),
        library: genPageTheme({
            colors: ['#6c2c8c', '#6c2c8c', '#6c2c8c', '#6c248c'],
            shape: shapes.wave,
        }),
        other: genPageTheme({ colors: ['#6c2c8c', '#6c2c8c', '#6c2c8c', '#6c248c'], shape: shapes.wave }),
        app: genPageTheme({ colors: ['#6c2c8c', '#6c2c8c', '#6c2c8c', '#6c248c'], shape: shapes.wave }),
        apis: genPageTheme({ colors: ['#6c2c8c', '#6c2c8c', '#6c2c8c', '#6c248c'], shape: shapes.wave }),
    },
});